/** @format */

export function isCookiesPolicy() {
  return window.location.href.split("/").reverse()[0] === "cookies-policy";
}
